<template>
  <div class="drag-drop-question-view">
    <!-- <div class="question-desc-view">{{questioninfo.desc}}</div> -->
    <template
      v-if="questionData.content_audio&&questionData.content_audio!=''&&questionData.content_audio!=null">
      <div class="question-play-btn"
           @click="playcontent(questionData.content_audio)">
        <div>听力材料</div>
      </div>
    </template>
    <div class="drag-drop-question-info-view" :style="showanswer?'background:#fff':''">
      <div class="drag-drop-question-content-info-view" v-if="!showanswer">
        <div class="drag-drop-el-left-btn"
             v-if="questioninfo.contents!=undefined&&localbottompage>1&&questioninfo.contents.length>0"
             @click="prevbottompage"></div>
        <draggable :list="questioninfo.contents"
                   :options="{group:{name: falgs,pull:'clone'},filter: '.undraggable', sort: false}"
                   @start="start"
                   :move="update"
                   @end="end"
                   class="drag-drop-drag1Area">
          <div class="drag-drop-drag1Area-item" v-for="(content,index) in questioninfo.contents" :data-index="index"
               v-if="index<3*localbottompage&&index>=(localbottompage-1)*3&&questioninfo.contents !== undefined && questioninfo.contents.length>0"
               :class="{undraggable : content.flag}">
            {{content.content}}
          </div>
        </draggable>
        <div class="drag-drop-el-right-btn"
             v-if="questioninfo.contents!=undefined&&localbottompage<bottompages&&questioninfo.contents.length>0"
             @click="nextbottompage"></div>
      </div>

      <div class="drag-drop-question-content-info-view1"
           v-if="questioninfo.contentsimg!=undefined&&questioninfo.contentsimg.length>0">
        <div class="drag-drop-el-left-btn" v-if="localtoppage>1" @click="prevtoppage"></div>
        <template v-for="(item,index) in questioninfo.contentsimg"
                  v-if="index<3*localtoppage&&index>=(localtoppage-1)*3&&questioninfo.contentsimg !== undefined && questioninfo.contentsimg.length>0">
          <div class="drag-drop-drag1Area-item1">
            <draggable :list="item.list"
                       :options="{group:item.flags,filter: '.list-complete-item-handle', disabled: disabled}"
                       class="dragArea11"
                       :data-index="index"
                       :id="'drag'+index">
              <div v-for="(element) in item.list" :key="element.id">
                <div class="list-complete-item-handle" v-if="element" @click="removeItem(index,$event)">
                  {{element.content}}
                </div>
              </div>
            </draggable>
            <div :id="'dragcontent'+index" class="drag-drop-content-img"
                 :style="'background-image:url('+baseurl+item.img+');background-size:100% 100%;'"
                 v-if="item.img&&item.img.length>0"/>
            <div class="content-text" v-else>{{item.content}}</div>

          </div>
        </template>
        <div class="drag-drop-el-right-btn" v-if="localtoppage<toppages" @click="nexttoppage"></div>
      </div>
    </div>

    <audio ref="dragmusic" controls="controls" style="display: none"
           preload="auto" @ended="playend">
      <source :src="audiourl" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>
  import apiUtil from "@/api/apiUtils"
  import Apis from "@/api"
  import Vue from 'vue';
  import draggable from 'vuedraggable'

  export default {
    name: "dragdropquestion",
    components: {draggable},
    data() {
      return {
        baseurl: apiUtil.getBaseUrl(),
        questioninfo: {},
        optionindex: 0,
        answerindex: 0,
        toppages: 1,
        bottompages: 1,
        localtoppage: 1,
        localbottompage: 1,
        disabled: false,
        falgs: 'article',
        showrightflag: false,
        showwrongflag: false,
        answerflags: true,
        showanswer: false,
        audiourl: "",
        rightaudio: "../../../static/mp3/right3.mp3",
        wrongaudio: "../../../static/mp3/wrong3.mp3",
        showdesc: true,
        localindex: 0,
        totalindex: 0,
        contentplay: false,
        descplay: false
      }
    },
    props: {
      questionData: {
        type: Object,
        default: function () {
          return {}
        }
      },
      isShowHead: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      "questionData": function () {
        this.initData()
      }
    },
    mounted() {
      let _this = this;
      this.$nextTick(() => {
        _this.initData()
      })
    },
    methods: {
      showdescbtn() {
        if (this.showdesc == false) {
          this.showdesc = true;
          this.$refs.dragmusic.pause()
        }
      },
      initData() {
        this.questioninfo = this.paraseData(this.questionData)
      },
      paraseData() {
        var that = this;
        var questiondata = {}
        if (!this.questionData.useroption) {
          questiondata = JSON.parse(JSON.stringify(this.questionData))
          let contents = questiondata.content.replace(/\\n/g, "</br>").split("|");
          let contentimgs = questiondata.options.split("|")
          var answerslist = [];
          var answers = questiondata.answer.split("&")
          answers.forEach(answeritem => {
            var answer = answeritem.split("|")
            answerslist.push(answer)
          })
          var contentimginfos = []
          var contentsinfos = []
          var contentsinfo = that.randomSort(contents);
          var contentsimg = that.randomSort(contentimgs);
          contentsinfo.forEach(item => {
            contentsinfos.push({
              content: item,
              falgs: false,
            })
          })
          contentsimg.forEach(item => {
            var contentimginfo = {
              img: item,
              list: [],
              flags: "article"
            }
            contentimginfos.push(contentimginfo)
          })
          questiondata.contents = contentsinfos
          questiondata.contentsimg = contentimginfos;
          questiondata.answers = answerslist;
          questiondata.useroption = [];
        } else {
          questiondata = JSON.parse(JSON.stringify(this.questionData))

        }
        this.toppages = parseInt(Math.ceil(questiondata.contentsimg.length / 3));
        this.bottompages = parseInt(Math.ceil(questiondata.contents.length / 3));
        return questiondata;
      },
      removeItem(index, event) {
        if (this.questioninfo.contentsimg[index].list.length > 0) {
          var item = this.questioninfo.contentsimg[index].list[0]
          this.questioninfo.contentsimg[index].list = [];
          this.questioninfo.contents.push(item)
        }
        event.stopPropagation()
      },
      nextbottompage() {
        this.localbottompage += 1;
        if (this.localbottompage > this.bottompages) {
          this.localbottompage = this.bottompages
        }
      },
      prevbottompage() {
        this.localbottompage -= 1;
        if (this.localbottompage < 0) {
          this.localbottompage = 0
        }
      },
      nexttoppage() {
        this.localtoppage += 1;
        if (this.localtoppage > this.toppages) {
          this.localtoppage = this.toppages
        }
      },
      prevtoppage() {
        this.localtoppage -= 1;
        if (this.localtoppage < 0) {
          this.localtoppage = 0
        }
      },
      hasClass(elements, cName) {
        return !!elements.className.match(new RegExp("(\\s|^)" + cName + "(\\s|$)"));
      },
      addClass(elements, cName) {
        if (!this.hasClass(elements, cName)) {
          elements.className += " " + cName;
        }
        ;
      },
      removeClass(elements, cName) {
        if (this.hasClass(elements, cName)) {
          elements.className = elements.className.replace(new RegExp("(\\s|^)" + cName + "(\\s|$)"), " ");
        }
      },
      update(ev) {
        ev.dragged.className += " nodragArea111";
      },
      start(ev) {
        ev.clone.className += " nodragArea11";
      },
      end(ev) {
        // console.log(ev)
        this.removeClass(ev.item, "nodragArea111")
        this.removeClass(ev.to, "nodragArea11")
        this.removeClass(ev.clone, "nodragArea11")
        this.removeClass(ev.from, "nodragArea11")
        if (ev.to.className.trim() === 'dragArea11') {  //to是目标位置 item是拖拽元素 clone是复制的元素（在原拖拽区域）from是原拖拽区域
          if (ev.to.childElementCount == 1) {  //如果目标拖拽区域（to）里面已经有1个子元素了 就将原来的踢出去

            this.questioninfo.contents.splice(ev.clone.dataset.index, 1)
            this.checkfinish()
            // var q = this.questioninfo.answers.find((value, index, arr) => {
            //   return value[1] === contentimg.img
            // })
            // if (q[0] == contentimg.list[0].content) {
            //   this.addClass(docdrag, "drag-check-right")
            //   this.addClass(docdragcontent, "drag-check-right")
            //   this.showrightflag = true;
            //   this.playaudiotype(true)
            //   setTimeout(() => {
            //
            //     this.showrightflag = false;
            //     this.removeClass(docdrag, "drag-check-right")
            //     this.removeClass(docdragcontent, "drag-check-right")
            //     this.checkfinish()
            //   }, 500)
            // } else {
            //   this.showwrongflag = true;
            //   this.playaudiotype(false)
            //   this.addClass(docdrag, "drag-check-wrong")
            //   this.addClass(docdragcontent, "drag-check-wrong")
            //   setTimeout(() => {
            //     this.questioninfo.contentsimg[ev.to.dataset.index].list = [];
            //     this.showwrongflag = false;
            //     this.removeClass(docdrag, "drag-check-wrong")
            //     this.removeClass(docdragcontent, "drag-check-wrong")
            //   }, 500)
            //   this.answerflags = false
            // }
          } else {
            this.handleDel(1, this.questioninfo.contentsimg[ev.to.dataset.index].list) //设置title 根据title的index值确认是哪个拖拽区域
          }
        }
      },
      checkfinish() {
        if (this.questioninfo.contents.length == 0) {
          var useroption = []
          this.questioninfo.contentsimg.forEach(item => {
            useroption.push([item.list[0], item.img])
          })
          this.questioninfo.useroption = useroption;
          this.questioninfo.isfinish = true;
          this.$emit("questionfinish", this.questioninfo)
        }
      },
      handleDel(index, list) {
        if (list.length > 1) {
          list.splice(1, 1)
        }
      },
      playdesc(event) {
        let that = this;
        var params = {
          'text': that.questioninfo.desc,
          'activity': ""
        }
        apiUtil.httpServer(Apis.getAudioData, params).then(res => {
          if (res.code == 200) {
            var audiourl = apiUtil.getBaseUrl() + res.data.amazon_url;
            this.$refs.dragmusic.src = audiourl;
            if (that.$refs.dragmusic.paused) {
              that.$refs.dragmusic.play();
              that.descplay = true
            }
          }
        })
        event.stopPropagation();
      },
      deschide() {
        this.showdesc = false;
        this.$refs.dragmusic.pause()
      },
      playcontent() {
        var audiourl = apiUtil.getBaseUrl() + this.questioninfo.content_audio;
        this.$refs.dragmusic.src = audiourl;
        if (this.$refs.dragmusic.paused) {
          this.$refs.dragmusic.play()
          this.contentplay = true
        }
      },
      playaudiotype(type) {
        var audiourl = "";
        if (type) {
          audiourl = this.rightaudio;
        } else {
          audiourl = this.wrongaudio;
        }
        this.$refs.dragmusic.src = audiourl;
        if (this.$refs.dragmusic.paused) {
          this.$refs.dragmusic.play()
        } else {
          this.$refs.dragmusic.pause()
        }
      },
      prev() {
        this.$refs.dragmusic.pause()
        this.descplay = false;
        this.contentplay = false;
        this.$emit("goToPrev")
      },
      next() {
        this.$refs.dragmusic.pause()
        this.descplay = false;
        this.contentplay = false;
        this.$emit("goToNext")
      },
      playend() {
        this.descplay = false;
        this.contentplay = false;
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../assets/css/common.styl";
  .drag-drop-question-view {
    width 100%;
    height 100%;
  }

  .drag-drop-question-info-view {
    display flex;
    width 100%;
    height 75%;
    position relative;
    display flex;
    flex-direction column;
    justify-content space-around;
    align-items center;
  }

  .content-tiem-view2 {
    width 582px;
  }

  .drag-drop-el-left-btn {
    width 38px;
    height 38px;
    position absolute;
    float left;
    left 18px;
    margin 40px 10px 10px 10px;
    background url("../../assets/img/el-left-img.png");
    background-size 100% 100%;
  }

  .drag-drop-el-right-btn {
    width 38px;
    height 38px;
    position absolute;
    float right;
    right 18px;
    margin 40px 10px 10px 10px;
    background url("../../assets/img/el-right-img.png");
    background-size 100% 100%;
  }

  .drag-drop-question-content-info-view {
    width 90%;
    height 50%;
    margin 10px auto;
    display flex;
    flex-direction row;
    align-items start;
    justify-content space-around;
  }

  .drag-drop-question-content-info-view1 {
    width 90%;
    height 50%;
    margin 10px auto;
    display flex;
    flex-direction row;
    align-items end;
    justify-content space-around;
  }

  .drag-drop-drag1Area {
    width 100%;
    display flex;
    float left;
  }

  .drag-check-right {
    border 3px solid #92C761 !important;
  }

  .drag-check-wrong {
    border 3px solid #F45578 !important;
  }

  .nodragArea11 {
    display none;
  }

  .nodragArea111 {
    border none;
    max-width 100px;
    width 100px;
    line-height 30px;
    font-size 42px;
    color #151515;
    text-align center;
    border none;
    margin none;
    border-radius none;
  }

  .undraggable {
    display none !important;
  }

  .dragArea11 {
    padding 0 10px;
    min-height 100px;
    font-size 36px;
    display flex;
    align-items center;
    text-align left;
    border 3px solid #000;
    border-radius 12px;
    background $_white;
  }

  .drag-drop-drag1Area-item {
    width 470px;
    padding 0 10px;
    min-height 100px;
    margin 20px;
    font-size 36px;
    display flex;
    align-items center;
    text-align left;
    border 3px solid #000;
    border-radius 15px;
    background $_white;
  }

  .drag-drop-drag1Area-item1 {
    width 490px;
    margin 20px;
  }

  .drag-drop-content-img {
    padding 60px 0;
    border 3px solid #000;
    border-radius 15px;
    background $_white;
    margin-top -3px;
  }

  .dragArea111 {
    padding 30px 0;
    background yellow;
    margin-top 50px;
    display flex;
    width 100%;
    flex-direction column;
  }

  .drag-drop-foot-view {
    width 100%;
    height 90px;
    position absolute;
    bottom 0;
    font-size 36px;

    .right-foot-view {
      display flex;
      width 100%;
      height 100%;
      display flex;
      align-items center;
      justify-content center;
      background #92C761;
      color #fff;
    }

    .wrong-foot-view {
      display flex;
      width 100%;
      height 100%;
      display flex;
      align-items center;
      justify-content center;
      background #F45578;
      color #fff;
    }

    .drag-drop-foot-view img {
      width 50px;
      height 50px;
      margin-right 22px;
    }
  }

  .drag-drop-show-answer-type-view {
    width 100%;
    font-size 30px;
    display: flex;
    justify-content center;
    align-items center;
  }

  .drag-drop-show-answer-type-view img {
    width 350px;
    height 180px;
    margin-bottom 10px;
  }

  @media screen and ( max-width: 1600px) {
    .drag-drop-question-info-view {
    }

    .drag-drop-drag1Area-item {
      width 470px;
      padding 0 10px;
      min-height 80px;
      margin 20px;
      font-size 24px;
      display flex;
      align-items center;
      text-align left;
      border 3px solid #000;
      border-radius 15px;
      background $_white;
    }

    .drag-drop-drag1Area-item1 {
      width 470px;
      margin 20px;
    }

    .dragArea11 {
      padding 0 10px;
      min-height 80px;
      font-size 36px;
      display flex;
      align-items center;
      text-align left;
      border 3px solid #000;
      border-radius 12px;
      background $_white;
    }

    .drag-drop-content-img {
      padding 40px 0;
      border 3px solid #000;
      border-radius 15px;
      background $_white;
      margin-top -3px;
    }
  }

  @media screen and ( max-width: 1366px) {
    .drag-drop-question-info-view {
      display flex;
      width 100%;
      height 80%;
      position relative;
      display flex;
      flex-direction column;
      justify-content space-around;
      align-items center;
    }

    .drag-drop-drag1Area-item {
      width 470px;
      padding 0 10px;
      min-height 80px;
      margin 20px;
      font-size 24px;
      display flex;
      align-items center;
      text-align left;
      border 3px solid #000;
      border-radius 15px;
      background $_white;
    }

    .drag-drop-drag1Area-item1 {
      width 470px;
      margin 20px;
    }

    .dragArea11 {
      padding 0 10px;
      min-height 80px;
      font-size 36px;
      display flex;
      align-items center;
      text-align left;
      border 3px solid #000;
      border-radius 12px;
      background $_white;
    }

    .drag-drop-content-img {
      padding 40px 0;
      border 3px solid #000;
      border-radius 15px;
      background $_white;
      margin-top -3px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/dragdropquestion.vue